export const DateHelper = {
  dateNowInSeconds: () => {
    const now = Date.now();
    return (now - (now % 1000)) / 1000;
  }
};
